import React from 'react';
import { Instagram, Facebook, Youtube } from 'lucide-react';
import Logo from '../atoms/Logo';

const Footer = () => {
    return (
        <footer className="bg-white border-t border-gray-100 py-16 px-6">
            <div className="container mx-auto grid md:grid-cols-4 gap-12">
                <div className="col-span-1 md:col-span-1">
                    <Logo className="mb-6" />
                    <p className="text-gray-500 text-sm leading-relaxed">Redefining the nail salon experience with art, precision, and longevity.</p>
                </div>

                <div>
                    <h4 className="font-bold uppercase tracking-widest text-xs mb-6">Studio</h4>
                    <ul className="space-y-4 text-sm text-gray-500">
                        <li>123 Melrose Ave</li>
                        <li>Los Angeles, CA 90046</li>
                        <li>hello@richtran.com</li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-bold uppercase tracking-widest text-xs mb-6">Information</h4>
                    <ul className="space-y-4 text-sm text-gray-500">
                        <li><a href="/" className="hover:text-black">Services Menu</a></li>
                        <li><a href="/" className="hover:text-black">Aftercare Guide</a></li>
                        <li><a href="/" className="hover:text-black">Cancellation Policy</a></li>
                        <li><a href="/" className="hover:text-black">FAQ</a></li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-bold uppercase tracking-widest text-xs mb-6">Social</h4>
                    <div className="flex gap-4">
                        <a href="https://www.instagram.com/rich.trannnnnails/" target="_blank" rel="noopener noreferrer" className="p-2 bg-gray-100 rounded-full hover:bg-black hover:text-white transition-colors"><Instagram className="w-5 h-5" /></a>
                        <a href="/" className="p-2 bg-gray-100 rounded-full hover:bg-black hover:text-white transition-colors"><Facebook className="w-5 h-5" /></a>
                        <a href="/" className="p-2 bg-gray-100 rounded-full hover:bg-black hover:text-white transition-colors"><Youtube className="w-5 h-5" /></a>
                    </div>
                </div>
            </div>

            <div className="container mx-auto mt-16 pt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center text-xs text-gray-400">
                <p>© 2026 Rich Tran Artistry. All rights reserved.</p>
                <div className="flex gap-6 mt-4 md:mt-0">
                    <a href="/">Privacy Policy</a>
                    <a href="/">Terms of Service</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
